import { request } from "@/utils/request";

export function getDeptList(params) {
  return request({
    url: '/system/dept/list',
    method: 'get',
    params
  })
}

export function saveDept(data) {
  return request({
    url: '/system/dept/save',
    method: 'post',
    data
  })
}

export function deleteDept(ids) {
  return request({
    url: '/system/dept/remove',
    method: 'post',
    data: ids
  })
}

export function addMembers(data) {
  return request({
    url: '/system/dept/addMembers',
    method: 'post',
    data
  })
}


export function removeMembers(data) {
  return request({
    url: '/system/dept/removeMembers',
    method: 'post',
    data
  })
}

export function getDeptMembers(params) {
  return request({
    url: '/system/dept/getDeptMembers',
    method: 'get',
    params
  })
}
